import { Toaster } from 'react-hot-toast';

const Error = () => <Toaster position="top-right" />;

export default Error;
